import { getImage, IGatsbyImageData, ImageDataLike } from 'gatsby-plugin-image';
import { TeamMemberListQuery, TeamPageQuery } from '../../../../graphql-types';

export class Team {
  id: string;
  name: string;
  team_members!: TeamMember[];

  constructor(private source: QueryTeam) {
    this.id = source.id;
    this.name = source.name!;

    if ((source as ListingTeam).team_members!) {
      this.team_members = (source as ListingTeam).team_members!.map<TeamMember>((team) => ({
        joined: team!.joined,
        id: team!.id,
        name: team!.name!,
        role: team!.role!,
        reviews: team!.reviews!,
        verified: team!.verified!,
        publishedAt: new Date(team!.publishedAt!),
        publishedAtRel: team!.publishedAtRel,
        slug: team!.slug!,
        description: team!.description!,
        publishedAtFormatted: team!.publishedAtFormatted,
        content: team!.biography!.data!.childMarkdownRemark!.html!,
        biography: team!.biography!.data!.biography!,
        teamphoto: getImage(team!.photo!.localFile as ImageDataLike)!,
        signatureImg: getImage(team!.signature!.localFile as ImageDataLike)!,
        bannerphoto: getImage(team!.bannerImage!.localFile as ImageDataLike)!
      }));
    }
  }
}
export class TeamDetail {
  id: string;
  joined: string;
  role: string;
  name: string;
  publishedAt: Date;
  publishedAtRel: string;
  publishedAtFormatted: string;
  biography: string;
  description: string;
  content: string;
  reviews: number;
  verified: boolean;
  location: string;
  videoUrl: string;
  videoTitle: string;
  slug: string;
  email: string;
  related_tags!: ({ tag?: string | null | undefined } | null)[];
  private signature!: ImageDataLike;

  get signatureImg() {
    return getImage(this.signature!);
  }
  private photo?: ImageDataLike;

  get teamphoto() {
    return getImage(this.photo!);
  }
  private bannerImage?: ImageDataLike;
  get bannerphoto() {
    return getImage(this.bannerImage!);
  }

  constructor(private source: PageTeam) {
    this.id = source.id;
    this.name = source.name!;
    this.joined = source!.joined;
    this.role = source!.role!;
    this.reviews = source!.reviews!;
    this.verified = source!.verified!;
    this.publishedAt = new Date(source!.publishedAt!);
    this.publishedAtRel = source!.publishedAtRel;
    this.publishedAtFormatted = source!.publishedAtFormatted;
    this.content = source!.biography!.data!.childMarkdownRemark!.html!;
    this.biography = source!.biography!.data!.biography!;
    this.location = source!.location!;
    this.videoUrl = source!.videoUrl!;
    this.slug = source!.slug!;
    this.description = source!.description!;
    this.videoTitle = source!.videoTitle!;
    this.email = source!.email!;
    if (source!.related_tags) {
      this.related_tags = source.related_tags;
    }
    if (source.photo) {
      this.photo = source.photo.localFile as ImageDataLike;
    }
    if (source.signature) {
      this.signature = source.signature.localFile as ImageDataLike;
    }
    if (source.bannerImage) {
      this.bannerImage = source.bannerImage.localFile as ImageDataLike;
    }
  }
}
export class TeamDetailListing {
  teamDetail: TeamDetail[];

  constructor() {
    this.teamDetail = [];
  }

  add(detail: TeamDetail) {
    this.teamDetail.push(detail);
  }
}
export class TeamListing {
  teams: Team[];

  constructor() {
    this.teams = [];
  }

  add(team: Team) {
    this.teams.push(team);
  }
}
export interface TeamMember {
  id: string;
  joined: string;
  role: string;
  name: string;
  publishedAt: Date;
  publishedAtRel: string;
  publishedAtFormatted: string;
  biography: string;
  signatureImg: IGatsbyImageData;
  content: string;
  description: string;
  teamphoto: IGatsbyImageData;
  bannerphoto: IGatsbyImageData;
  reviews: number;
  slug: string;
  verified: boolean;
}
type ListingTeam = TeamMemberListQuery['allStrapiTeam']['edges'][0]['node'];
type PageTeam = NonNullable<TeamPageQuery['allStrapiTeamMember']['edges'][0]['node']>;

export type QueryTeam = ListingTeam;
